// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mid-game {
  height: 100dvh;
  width: 100vw;
  display: flex;
  flex-direction: column;
}
.mid-game__image-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.mid-game__image {
  position: relative;
  z-index: 2;
}
.mid-game__top-outer-container {
  background-color: #1f48b1;
}
.mid-game__top-inner-container {
  padding: 0 1rem 0;
}
@media all and (min-width: 1280px) {
  .mid-game__top-inner-container {
    max-width: 581px;
  }
}
@media all and (min-width: 1280px) {
  .mid-game__middle-inner-container {
    max-width: 581px;
  }
}
.mid-game__middle-outer-container {
  background-color: #1f48b1;
  position: relative;
}
.mid-game__description {
  margin-top: 12px;
}
.mid-game__bottom-outer-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fbfbfb;
  flex-grow: 1;
  height: 100%;
}
.mid-game__bottom-inner-container {
  z-index: 3;
  padding: 0 1rem;
  height: 100%;
  display: flex;
  flex-direction: column;
}
@media all and (min-width: 1280px) {
  .mid-game__bottom-inner-container {
    max-width: 700px;
    padding: 0;
  }
}
.mid-game__button-container {
  display: grid;
  grid-gap: 12px;
  margin-top: 102px;
  justify-content: center;
  grid-template-columns: 1fr;
}
@media all and (min-width: 1280px) {
  .mid-game__button-container {
    grid-template-columns: 1fr 1fr;
    grid-gap: 20px;
    margin-top: 5rem;
  }
}
.mid-game__button-container--short {
  display: flex;
  grid-template-columns: 1fr;
  justify-content: center;
}
.mid-game__arrr {
  display: flex;
  flex-grow: 1;
  align-items: flex-end;
  justify-content: center;
  height: 100%;
}
.mid-game__footer-container {
  display: flex;
  justify-content: center;
}
.mid-game__snow-lines--back {
  bottom: -3rem;
}
@media all and (min-width: 1280px) {
  .mid-game__snow-lines--back {
    bottom: -1rem;
  }
}
.mid-game__snow-lines--front {
  bottom: -5rem;
}
@media all and (min-width: 1280px) {
  .mid-game__snow-lines--front {
    bottom: -4rem;
  }
}
.mid-game__button--short {
  padding: 20px 90px;
}
@media all and (min-width: 1280px) {
  .mid-game__button--short {
    width: fit-content;
  }
}

.special-button {
  padding: 0;
}

.special-link {
  padding: 20px 40px;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/pages/MidGame/MidGame.scss","webpack://./src/styles/variables.scss"],"names":[],"mappings":"AAEA;EACE,cAAA;EAEA,YAAA;EACA,aAAA;EACA,sBAAA;AAFF;AAIE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAFJ;AAKE;EACE,kBAAA;EACA,UAAA;AAHJ;AAME;EACE,yBCZgB;ADQpB;AAOE;EACE,iBAAA;AALJ;AAMI;EAFF;IAGI,gBAAA;EAHJ;AACF;AAOI;EADF;IAEI,gBAAA;EAJJ;AACF;AAOE;EACE,yBC7BgB;ED8BhB,kBAAA;AALJ;AAYE;EACE,gBAAA;AAVJ;AAaE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBCrBQ;EDsBR,YAAA;EACA,YAAA;AAXJ;AAcE;EACE,UAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AAZJ;AAcI;EAPF;IAQI,gBAAA;IACA,UAAA;EAXJ;AACF;AAcE;EACE,aAAA;EACA,cAAA;EACA,iBAAA;EACA,uBAAA;EACA,0BAAA;AAZJ;AAeI;EARF;IASI,8BAAA;IACA,cAAA;IACA,gBAAA;EAZJ;AACF;AAcI;EACE,aAAA;EACA,0BAAA;EACA,uBAAA;AAZN;AAgBE;EACE,aAAA;EACA,YAAA;EACA,qBAAA;EACA,uBAAA;EACA,YAAA;AAdJ;AAiBE;EACE,aAAA;EACA,uBAAA;AAfJ;AAoBI;EACE,aAAA;AAlBN;AAoBM;EAHF;IAII,aAAA;EAjBN;AACF;AAoBI;EACE,aAAA;AAlBN;AAoBM;EAHF;IAII,aAAA;EAjBN;AACF;AAqBE;EACE,kBAAA;AAnBJ;AAqBI;EAHF;IAII,kBAAA;EAlBJ;AACF;;AAuBA;EACE,UAAA;AApBF;;AAuBA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;AApBF","sourcesContent":["@import 'src/styles/variables';\n\n.mid-game {\n  height: 100dvh;\n\n  width: 100vw;\n  display: flex;\n  flex-direction: column;\n\n  &__image-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  &__image {\n    position: relative;\n    z-index: 2;\n  }\n\n  &__top-outer-container {\n    background-color: $main-mid-blue-100;\n  }\n\n  &__top-inner-container {\n    padding: 0 1rem 0;\n    @media all and (min-width: $desktop) {\n      max-width: 581px;\n    }\n  }\n\n  &__middle-inner-container {\n    @media all and (min-width: $desktop) {\n      max-width: 581px;\n    }\n  }\n\n  &__middle-outer-container {\n    background-color: $main-mid-blue-100;\n    position: relative;\n\n    @media all and (min-width: $desktop) {\n\n    }\n  }\n\n  &__description {\n    margin-top: 12px;\n  }\n\n  &__bottom-outer-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    background-color: $white-100;\n    flex-grow: 1;\n    height: 100%;\n  }\n\n  &__bottom-inner-container {\n    z-index: 3;\n    padding: 0 1rem;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n\n    @media all and (min-width: $desktop) {\n      max-width: 700px;\n      padding: 0;\n    }\n  }\n\n  &__button-container {\n    display: grid;\n    grid-gap: 12px;\n    margin-top: 102px;\n    justify-content: center;\n    grid-template-columns: 1fr;\n\n\n    @media all and (min-width: $desktop) {\n      grid-template-columns: 1fr 1fr;\n      grid-gap: 20px;\n      margin-top: 5rem;\n    }\n\n    &--short {\n      display: flex;\n      grid-template-columns: 1fr;\n      justify-content: center;\n    }\n  }\n\n  &__arrr {\n    display: flex;\n    flex-grow: 1;\n    align-items: flex-end;\n    justify-content: center;\n    height: 100%;\n  }\n\n  &__footer-container {\n    display: flex;\n    justify-content: center;\n  }\n\n\n  &__snow-lines {\n    &--back {\n      bottom: -3rem;\n\n      @media all and (min-width: $desktop) {\n        bottom: -1rem;\n      }\n    }\n\n    &--front {\n      bottom: -5rem;\n\n      @media all and (min-width: $desktop) {\n        bottom: -4rem;\n      }\n    }\n  }\n\n  &__button--short {\n    padding: 20px 90px;\n\n    @media all and (min-width: $desktop) {\n      width: fit-content;\n    }\n  }\n\n}\n\n.special-button {\n  padding: 0;\n}\n\n.special-link {\n  padding: 20px 40px;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n}","$headerHeightMobile: 60px;\n$headerHeightDesktop: 80px;\n\n$desktop: 1280px;\n\n\n// accents\n$main-blue-gradient: #100;\n$main-dark-blue: #1F106D;\n$main-mid-blue-100: #1F48B1FF;\n$main-mid-blue-50: #1F48B180;\n$main-light-blue: #A1C7FF;\n$hover-main-blue: #331CAA;\n$pressed-main-blue: #011C5A;\n$progress-bar-red: #D62B1F;\n$progress-dot-disabled: #D9D9D9;\n\n// brands\n$alfa-bank: #EF3124;\n$vsk: #4544EE;\n$h: #2078FE;\n$vtb: #002882;\n$robo-finance: #00BF6E;\n$x-5: #5FAF2D;\n$sport-master: #1551E5;\n\n// black\n$black-100: #151515FF;\n$black-75: #151515BF;\n$black-50: #15151580;\n$black-25: #15151540;\n\n// white\n$white-100: #FBFBFBFF;\n$white-75: #FBFBFBBF;\n$white-50: #FBFBFB80;\n$white-25: #FBFBFB40;\n\n// input\n$input-background: #F1F5F9;\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
